<template lang="pug">
slot(v-if="isMounted && $slots.default" name="default")
slot(v-else-if="!isMounted && $slots.ssr" name="ssr")
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'

const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})
</script>